module.exports = __webpack_public_path__ + "static/media/rasp-save.b79181df.svg";